module.exports = __webpack_public_path__ + "img/hx.81cb04a1.gif";